import { consola } from "consola/browser";

const setLogLevel = () => {
    if (import.meta.env.TEST) {
        return 1;
    }

    if (import.meta.env.DEV) {
        return 4;
    }

    return 2;
};

const logger = consola.create({
    formatOptions: {
        colors: true,
        date: true,
    },
    level: setLogLevel(),
});

logger.level = setLogLevel();

export default logger;
